//console.log("hello world");

//mobile nav toggle

jQuery(window).on('load', function() { // makes sure the whole site is loaded


jQuery( ".hamburger" ).click(function() {
  jQuery( ".hamburger" ).fadeToggle( "fast", "linear" );
});

jQuery( ".close" ).click(function() {
  jQuery( ".hamburger" ).fadeToggle( "fast", "linear" );
});

});


//requied for cf7 checkbox style

jQuery( document ).ready(function() {
  jQuery( "<span class='checkmark'></span>" ).insertAfter( ".wpcf7-list-item input" );
});


//testimonials

jQuery('.owl-carousel-testimonials').owlCarousel({
    loop:true,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    nav:true,
    dots:true,
    autoplay:true,
    autoplayHoverPause:false,
    autoplayTimeout:6000,
    responsive:{
        0:{
            items:1
        }
    }
})

//results

jQuery('.owl-carousel-results').owlCarousel({
    loop:true,
    nav:true,
    dots:true,
    autoplay:true,
    autoplayHoverPause:true,
    responsive:{
        0:{
            items:1
        }
    }
})



//timeline

  jQuery('.owl-carousel-timeline').owlCarousel({
  loop:true,
  center: true,
  nav:true,
  responsive:{
      0:{
          items:1
      },
      980:{
          items:3
      }
  }
})


//Greensock animations

var controller = new ScrollMagic.Controller();

  // loop through all elements
  jQuery('.panel--intro-4-usp .usp, .panel--team-tabs .card, .panel--sectors .tabs-content img, .scrollappear').each(function() {

    // build a tween
    var tween = TweenMax.from(jQuery(this), 2, {autoAlpha: 0, y: 40, ease: Power3.easeOut});

    // build a scene
    var scene = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 'onEnter', offset: 50
    })
    .setTween(tween) // trigger a TweenMax.to tween
    .addTo(controller);
});



// init controller
var controller2 = new ScrollMagic.Controller();


// movement helpers

var movebg_helper = new TimelineMax ()
.add([
  TweenMax.to(".movebg-helper", 1, {backgroundPosition: "0 105%", ease: Linear.expo}),
]);


// covers

// var imgtween_cover = new TimelineMax ()
// .add([
//   TweenMax.to(".cover", 1, {backgroundPosition: "0 120%", ease: Linear.expo}),
// ]);


//2col image / text

  // build tween
  var imgtween_horizontal = new TimelineMax ()
  .add([
      TweenMax.fromTo(".panel--2col.textimage.instance1 .move-img-horizontal", 1, {x: 75}, {x: 20, ease: Linear.expo}),
      TweenMax.to(".panel--2col.textimage.instance1 .move-img-bg", 1, {backgroundPosition: "110% 0", ease: Linear.expo}),
  ]);

  // build tween
  var imgtween_vertical = new TimelineMax ()
  .add([
      TweenMax.fromTo(".panel--2col.textimage.instance1 .move-up", 1, {y: 40}, {y: 0, ease: Linear.expo}),
  ]);


  // build tween
  var imgtween_horizontal_instance2 = new TimelineMax ()
  .add([
      TweenMax.fromTo(".panel--2col.textimage.instance2 .move-img-horizontal", 1, {x: 75}, {x: 20, ease: Linear.expo}),
      TweenMax.to(".panel--2col.textimage.instance2 .move-img-bg", 1, {backgroundPosition: "110% 0", ease: Linear.expo}),
  ]);

  // build tween
  var imgtween_vertical_instance2 = new TimelineMax ()
  .add([
      TweenMax.fromTo(".panel--2col.textimage.instance2 .move-up", 1, {y: 40}, {y: 0, ease: Linear.expo}),
  ]);


  //2col image / quote

  // build tween
  var imgtween_horizontal2 = new TimelineMax ()
  .add([
      TweenMax.fromTo(".panel--2col.textquote .move-img-horizontal", 1, {x: 75}, {x: 20, ease: Linear.expo}),
      TweenMax.to(".panel--2col.textquote .move-img-bg", 1, {backgroundPosition: "110% 0", ease: Linear.expo}),
  ]);

  // build tween
  var imgtween_vertical2 = new TimelineMax ()
  .add([
      TweenMax.fromTo(".panel--2col.textquote .move-up", 1, {y: 40}, {y: 0, ease: Linear.expo}),
  ]);



  //4usp

    // build tween
    var imgtween_horizontal3 = new TimelineMax ()
    .add([
        TweenMax.fromTo(".panel--intro-4-usp .move-img-horizontal", 1, {x: 100}, {x: 0, ease: Linear.expo}),
        TweenMax.fromTo(".panel--intro-4-usp .move-img-horizontal", 1, {y: 200}, {y: 0, ease: Linear.expo}),
        TweenMax.to(".panel--intro-4-usp .move-img-bg", 1, {backgroundPosition: "120% 0", ease: Linear.expo}),
    ]);

    // build tween
    var imgtween_vertical3 = new TimelineMax ()
    .add([
        TweenMax.fromTo(".panel--intro-4-usp .move-up", 1, {y: 550}, {y: 0, ease: Linear.expo}),
    ]);

    //circle stats

      // build tween
      var imgtween_horizontal4 = new TimelineMax ()
      .add([
          TweenMax.fromTo(".panel--circle-stat .move-img", 1, {x: 15}, {x: 0, ease: Linear.expo}),
          TweenMax.fromTo(".panel--circle-stat .move-img", 1, {y: -200}, {y: -200, ease: Linear.expo}),
          TweenMax.fromTo(".panel--circle-stat .move-img2", 1.2, {x: -10}, {x: 120, ease: Linear.expo}),
          TweenMax.fromTo(".panel--circle-stat .move-img2", 1.2, {y: -175}, {y: -175, ease: Linear.expo}),

          TweenMax.to(".panel--circle-stat .move-img-bg", 1.5, {backgroundPosition: "110% 0", ease: Linear.expo}),
      ]);

      // build tween
      var imgtween_vertical4 = new TimelineMax ()
      .add([
          TweenMax.fromTo(".panel--circle-stat .move-bg", 1.5, {x: -80}, {x: 0, ease: Linear.expo}),
          TweenMax.fromTo(".panel--circle-stat .move-bg", 1.5, {y: 300}, {y: 300, ease: Linear.expo}),
      ]);


  // build scenes

  //movement helpers

  new ScrollMagic.Scene({triggerElement: ".movebg-helper", duration: "100%"})
     .setTween(movebg_helper)
     .addTo(controller2);


  //covers

  // new ScrollMagic.Scene({triggerElement: ".cover .h1", duration: "100%"})
  //    .setTween(imgtween_cover)
  //    .addTo(controller2);



  //2col image / text


  new ScrollMagic.Scene({triggerElement: ".panel--2col.textimage.instance1", duration: "100%"})
     .setTween(imgtween_horizontal)
     .addTo(controller2);

  new ScrollMagic.Scene({triggerElement: ".panel--2col.textimage.instance1", duration: "100%"})
      .setTween(imgtween_vertical)
      .addTo(controller2);

      new ScrollMagic.Scene({triggerElement: ".panel--2col.textimage.instance2", duration: "100%"})
         .setTween(imgtween_horizontal_instance2)
         .addTo(controller2);

      new ScrollMagic.Scene({triggerElement: ".panel--2col.textimage.instance2", duration: "100%"})
          .setTween(imgtween_vertical_instance2)
          .addTo(controller2);

          // new ScrollMagic.Scene({triggerElement: ".panel--2col.textimage:nth-of-type(2)", duration: "100%"})
          //    .setTween(imgtween_horizontal_instance2)
          //    .addTo(controller2);
          //
          // new ScrollMagic.Scene({triggerElement: ".panel--2col.textimage:nth-of-type(2)", duration: "100%"})
          //     .setTween(imgtween_vertical_instance2)
          //     .addTo(controller2);

          //     new ScrollMagic.Scene({triggerElement: ".panel--2col.textimage.instance3", duration: "100%"})
          //        .setTween(imgtween_horizontal)
          //        .addTo(controller2);
          //
          //     new ScrollMagic.Scene({triggerElement: ".panel--2col.textimage.instance3", duration: "100%"})
          //         .setTween(imgtween_vertical)
          //         .addTo(controller2);
          //
          //         new ScrollMagic.Scene({triggerElement: ".panel--2col.textimage.instance4", duration: "100%"})
          //            .setTween(imgtween_horizontal)
          //            .addTo(controller2);
          //
          //         new ScrollMagic.Scene({triggerElement: ".panel--2col.textimage.instance4", duration: "100%"})
          //             .setTween(imgtween_vertical)
          //             .addTo(controller2);
          //
          //             new ScrollMagic.Scene({triggerElement: ".panel--2col.textimage.instance5", duration: "100%"})
          //                .setTween(imgtween_horizontal)
          //                .addTo(controller2);
          //
          //             new ScrollMagic.Scene({triggerElement: ".panel--2col.textimage.instance5", duration: "100%"})
          //                 .setTween(imgtween_vertical)
          //                 .addTo(controller2);

  //2col image / quote

  new ScrollMagic.Scene({triggerElement: ".panel--2col.textquote", duration: "100%"})

     .setTween(imgtween_horizontal2)
     .addTo(controller2);

  new ScrollMagic.Scene({triggerElement: ".panel--2col.textquote", duration: "100%"})
      .setTween(imgtween_vertical2)
      .addTo(controller2);

  //4usp

  new ScrollMagic.Scene({triggerElement: ".panel--intro-4-usp", duration: "100%"})

     .setTween(imgtween_horizontal3)
     .addTo(controller2);

  new ScrollMagic.Scene({triggerElement: ".panel--intro-4-usp", duration: "100%"})
      .setTween(imgtween_vertical3)
      .addTo(controller2);

      //circle stats

      new ScrollMagic.Scene({triggerElement: ".panel--circle-stat", duration: "100%"})

         .setTween(imgtween_horizontal4)
         .addTo(controller2);

      new ScrollMagic.Scene({triggerElement: ".panel--circle-stat", duration: "100%"})
          .setTween(imgtween_vertical4)
          .addTo(controller2);
